//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { dicOption } from "@/option/config";
import { getList as _getList, getObj, addObj, delObj, updateObj } from "@/api/bigscreen/category";
export default {
  data: function data() {
    return {
      dicOption: dicOption,
      options: [{
        value: "选项1",
        label: "黄金糕"
      }, {
        value: "选项2",
        label: "双皮奶"
      }, {
        value: "选项3",
        label: "蚵仔煎"
      }, {
        value: "选项4",
        label: "龙须面"
      }, {
        value: "选项5",
        label: "北京烤鸭"
      }],
      gatewayvalue: ""
    };
  },
  inject: ["main"],
  mounted: function mounted() {// this.getList()
  },
  watch: {
    gatewayvalue: function gatewayvalue(newVal) {
      this.getList();
    }
  },
  methods: {
    getList: function getList() {
      var _this = this;

      _getList({
        current: 1,
        size: 100
      }).then(function (res) {
        console.log(_this, res, " ---res");

        _this.main.handleTextSet(res.data.data[0].categoryKey);
      });
    }
  }
};